import * as React from 'react';
import PropTypes from 'prop-types';
import Placeholder from "./Placeholder";
import {Confirm, Icon, Label, Popup, Segment} from "semantic-ui-react";
import {translate} from "react-i18next";
import {IMAGE_URL} from "../misc/vars";
import {processData} from "ah-lib";
import {Subbar, Title, PageHeader, Sortable, SearchFilter, Tiles, Tile} from "ah-tools";
// import {Tile, Tiles} from "../misc/Tiles";
import ServiceImage from '../images/service2.png';
import {makeRoute, ROUTE_SERVICE_CREATE, ROUTE_SERVICE_DETAIL} from "../routes";
import {sort, sortDefault, sortNum} from "ith-sort";
import {compare, compareDefault, compareNum} from "ith-compare";
import {LOC_SERVICE_LIST} from "../actions";
import {IconButton} from "../extensions";

const filterOptions = [
	{key: 'title', text: 'Name', value: 'title'},
	{key: 'id', text: 'ID', value: 'id'}
];

const sortOptions = [
	{key: 'title-asc', order: 'ascending', title: 'Name aufsteigend'},
	{key: 'title-desc', order: 'descending', title: 'Name absteigend'},
	
	{key: 'service-id-asc', order: 'ascending', title: 'ID aufsteigend'},
	{key: 'service-id-desc', order: 'descending', title: 'ID absteigend'}
];

const _fromStorage = () => JSON.parse(window.localStorage.getItem(LOC_SERVICE_LIST)) || ({
	filter: filterOptions[0].key,
	text: '',
	order: sortOptions[0].key
});

class ServiceList extends React.Component {
	static propTypes = {
		currentService: PropTypes.object,
		services: PropTypes.array.isRequired,
		isLoading: PropTypes.bool,
		onSelect: PropTypes.func.isRequired,
		onDelete: PropTypes.func,
		isDeleting: PropTypes.func,
		push: PropTypes.func.isRequired
		
	};
	static defaultProps = {
		services: [],
		isLoading: false,
		onSelect: () => alert('onSelect() not implemented'),
		isDeleting: (service_id) => false,
		push: to => alert('push() is not implemented!')
	};
	state = {
		confirmDelete: null,
		selections: {},
		filter: _fromStorage(),
		_filter: {text: '', filter: filterOptions[0].key}
	};
	
	updateFilter = (index, value) => this.setState(state => ({
		...state,
		filter: {
			...state.filter,
			[index]: value
		}
	}));
	updateNormalFilter = (index, value) => this.setState(state => ({
		...state,
		_filter: { ...state._filter, [index]: value }
	}));
	
	translated = () => (data) => processData(data)(d => {
		d.translatedTitle = this.props.t([`service.name.service-${d.service_id}`, d.title]);
		d.isTranslated = d.translatedTitle !== d.title;
	});
	
	sorted = () => {
		const option = sortOptions.find(el => el.key === this.state.filter.order);
		const _ = option.key.split('-');
		const order = _.pop();
		const key = _.join('-');
		
		switch (key) {
			case 'title':
				return sort(order)(s => s.translatedTitle || s.title);
			case 'service-id':
				return sortNum(order)(s => s.service_id);
			default:
				return sortDefault;
		}
	};
	
	filtered = () => {
		const {_filter: {text, filter}} = this.state;
		if ( text.trim() === '') return compareDefault;
		switch (filter) {
			case 'title':
				return compare(text)(s => s.translatedTitle || s.title);
			case 'id':
				return compareNum(text)(s => ''+s.service_id);
			default:
				return compareDefault;
		}
	};
	
	setConfirm = (calllable=null) => this.setState({confirmDelete: calllable});
	
	render = () => {
		const {services, isLoading, push} = this.props;
		const {confirmDelete, filter, _filter} = this.state;
		// const services = serviceList;//.filter(this.searched());
		if (isLoading) {
			return <Placeholder repeat={3} style={{marginTop: 50}}/>
		}
		window.localStorage.setItem(LOC_SERVICE_LIST, JSON.stringify(filter));
		return (
			<Segment basic>
				<PageHeader align={Subbar.ALIGN_BETWEEN}>
					<Title loading={isLoading}>Serviceleistungen</Title>
					<Subbar>
						<Sortable
							options={sortOptions}
							value={filter.order}
							onChange={(_, key, value) => this.updateFilter('order', value)}
						/>
						<SearchFilter
							options={filterOptions}
							value={_filter.text}
							selected={_filter.filter}
							onChange={value => this.updateNormalFilter('text', value)}
							onSelect={value => this.updateNormalFilter('filter', value)}
						/>
						<Popup
							position={'left center'}
							inverted content={'Neue Serviceleistung erstellen'}
							trigger={
								<IconButton onClick={() => push(ROUTE_SERVICE_CREATE)}><Icon name={'plus'} size={'large'}/></IconButton>
							}/>
					</Subbar>
				</PageHeader>
				<Tiles>
					{services.map(this.translated()).filter(this.filtered()).sort(this.sorted()).map(({active, logo, service_id, title, translatedTitle}, index) =>
						<Tile
							key={`service-${service_id}`}
							style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center', position: 'relative'}}
							onClick={() => push(makeRoute(ROUTE_SERVICE_DETAIL, {service_id}))}
						>
							<div style={{marginBottom: 5, display: 'flex'}}>
								<img src={logo ? `${IMAGE_URL}${logo.ident}.${logo.origin_extension}?${logo.updated_at}` : ServiceImage} alt="service logo" style={{margin: 'auto'}} />
							</div>
							<strong><Label color={active ? 'grey' : 'red'} tag title={active ? null : 'Inaktiv'}>{translatedTitle}</Label></strong>
							<Label attached={'top left'}>{service_id}</Label>
						</Tile>
					)}
				</Tiles>
				<Confirm open={!!confirmDelete} onCancel={() => this.setConfirm()} onConfirm={() => confirmDelete()} cancelButton={'Nein'} confirmButton={'Ja'} content={'Wirklich löschen?'}/>
				{/*<pre>{JSON.stringify(services, null, 4)}</pre>*/}
			</Segment>
		);
	};
}

export default translate()(ServiceList);


// WEBPACK FOOTER //
// ./src/components/ServiceList.js